"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmniExternalSourcesFeature = OmniExternalSourcesFeature;
const practice_verse_web_1 = require("@branch-ts/practice-verse-web");
const src_1 = require("@branch-ts/practice-omni-web/src");
const git_consensus_1 = require("@branch-ts/git-consensus");
const log_consensus_1 = require("@branch-ts/log-consensus");
const seqop_consensus_1 = require("@branch-ts/seqop-consensus");
const verse_consensus_1 = require("@branch-ts/verse-consensus");
function OmniExternalSourcesFeature(config) {
    (0, practice_verse_web_1.FatSetupVerseExternalSourceAccess)().setup();
    (0, src_1.FatSetupFileSystemExternalSourceAccess)({}).setup({});
    git_consensus_1.GitRepoProviderRegistryMechanism.events.of.open.listenBy(config.owner, (info) => {
        config.omniCenter.addSource({
            essenceURI: info.uri,
        });
    });
    seqop_consensus_1.MediatorRegistryMechanism.events.of.open.listenBy(config.owner, (info) => {
        const verseInfo = verse_consensus_1.VerseProtocol.VerseURI.parse(info.uri);
        if (!verseInfo) {
            return;
        }
        log_consensus_1.Logger.log("Verse added to source", info.uri);
        config.omniCenter.addSource({
            essenceURI: info.uri,
        });
    });
}
